import { render } from "./proveLogin.vue?vue&type=template&id=1e1ed0a4"
import script from "./proveLogin.vue?vue&type=script&lang=js"
export * from "./proveLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__